import registerDatePickerLocales from './registerDatePickerLocales';
import registerYupLocale from './registerYupLocale';

export { registerDatePickerLocales, registerYupLocale };

export const registerLocale = (locale = I18n.locale) => {
  registerDatePickerLocales();
  registerYupLocale(locale);
};
